import { render, staticRenderFns } from "./form-unidade.vue?vue&type=template&id=9e117b04&"
import script from "./form-unidade.vue?vue&type=script&lang=js&"
export * from "./form-unidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports